import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaLink, FaCopy, FaShareAlt, FaUserFriends } from "react-icons/fa";
import api from "../utils/api";

function Invite() {
  const [user, setUser] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get("/auth/profile");
        setUser(res.data);
      } catch (err) {
        console.error("❌ فشل تحميل بيانات المستخدم", err);
      }
    };
    fetchProfile();
  }, []);

  if (!user)
    return (
      <div className="flex justify-center items-center h-screen text-yellow-400 text-xl">
        ⏳ جاري تحميل بيانات المستخدم...
      </div>
    );

  // ✅ إنشاء رابط الإحالة الديناميكي
  const referralLink = `${window.location.origin}/register?ref=${user._id}`;

  // ✅ نسخ الرابط
  const copyLink = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // ✅ مشاركة الرابط (للجوال)
  const shareLink = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "دعوة للانضمام إلى النظام القانوني الذكي ⚖️",
          text: "سجّل عبر رابطي الشخصي واستفد من المزايا!",
          url: referralLink,
        });
      } catch (err) {
        console.error("❌ خطأ أثناء المشاركة:", err);
      }
    } else {
      copyLink();
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white px-6">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="w-full max-w-xl bg-gray-900 border border-yellow-400/40 shadow-2xl rounded-2xl p-8 relative overflow-hidden"
      >
        {/* ✨ خلفية زخرفية */}
        <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_left,rgba(255,215,0,0.4),transparent_60%)]"></div>

        <div className="relative z-10 text-center">
          <FaUserFriends className="text-yellow-400 text-5xl mx-auto mb-4" />
          <h2 className="text-3xl font-bold mb-2 text-yellow-400">
            🎯 شارك موقعك مع أصدقائك
          </h2>
          <p className="text-gray-300 mb-6">
            انسخ أو شارك الرابط الخاص بك — وكل من يسجّل من خلاله يُضاف تحت حسابك تلقائيًا.
          </p>

          {/* 🔗 رابط الإحالة */}
          <div className="flex flex-col sm:flex-row items-center gap-3 mb-6">
            <div className="flex items-center w-full bg-gray-800 rounded-lg overflow-hidden border border-gray-700">
              <FaLink className="text-yellow-400 mx-3" />
              <input
                type="text"
                readOnly
                value={referralLink}
                className="flex-1 bg-transparent text-gray-200 p-3 focus:outline-none"
              />
            </div>

            <div className="flex gap-2 w-full sm:w-auto">
              <button
                onClick={copyLink}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-4 py-2 rounded-md transition"
              >
                <FaCopy />
                {copied ? "تم النسخ ✅" : "نسخ"}
              </button>

              <button
                onClick={shareLink}
                className="flex-1 sm:flex-none flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white font-bold px-4 py-2 rounded-md transition"
              >
                <FaShareAlt /> مشاركة
              </button>
            </div>
          </div>

          {/* 🧾 معلومات المستخدم */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="mt-8 bg-gray-800/70 border border-gray-700 rounded-xl p-5 text-sm text-gray-300 text-right"
          >
            <p>
              <span className="font-bold text-yellow-400">👤 الاسم:</span> {user.name}
            </p>
            <p>
              <span className="font-bold text-yellow-400">📧 البريد:</span> {user.email}
            </p>
            <p>
              <span className="font-bold text-yellow-400">⚖️ الدور:</span> {user.role}
            </p>
          </motion.div>

          <p className="mt-6 text-sm text-gray-500">
            📣 كل إحالة ناجحة تضيف إلى رصيدك! تابع من لوحة التحكم لتشوف الأشخاص اللي سجّلوا من خلالك.
          </p>
        </div>
      </motion.div>
    </div>
  );
}

export default Invite;
